import { Link } from "react-router-dom";
import { Phone } from "lucide-react";

export default function StickyMobileCTA() {
  return (
    <div data-testid="sticky-mobile-cta" className="sticky-cta lg:hidden py-3 px-4 flex gap-2">
      <Link
        to="/estimate"
        data-testid="sticky-estimate-btn"
        className="flex-1 text-center bg-[#8C1D30] hover:bg-[#7A1829] text-[#F5F3EF] py-3 text-sm tracking-wide"
      >
        Free Estimate
      </Link>
      <a
        href="tel:+17806557604"
        data-testid="sticky-call-btn"
        className="px-4 py-3 border border-[#D8D6D0]/30 text-[#F5F3EF] flex items-center"
      >
        <Phone className="w-4 h-4" />
      </a>
    </div>
  );
}
